<template>
    <div title="Your Information">
        <div class="row">
            <div class="col">
                <h4>Tell us about you</h4>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="contain">                
                <div class="row">
                    <div class="col">
                        <b-form-group
                            id="fieldset-0"
                            description=""
                            label="First Name"
                            label-for="first-name"
                        >
                            <b-form-input
                                id="first-name"
                                v-model="visitorInfo.firstName" 
                                :state="this.isElementValid($v.visitorInfo.firstName)"
                                @blur="updateSellerFirstName()"
                                aria-describedby="input-live-help input-live-feedback"
                                required
                                trim
                                lazy
                            />
                            <b-form-invalid-feedback id="input-live-feedback">
                                Enter your first name
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col">
                        <b-form-group
                            id="fieldset-0"
                            description=""
                            label="Last Name"
                            label-for="last-name"
                        >
                            <b-form-input
                                id="last-name"
                                v-model="visitorInfo.lastName" 
                                :state="this.isElementValid($v.visitorInfo.lastName)"
                                @blur="updateSellerLastName()"
                                aria-describedby="input-live-help input-live-feedback"
                                required
                                trim
                                lazy
                            />
                            <b-form-invalid-feedback id="input-live-feedback">
                                Enter your last name
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                </div>                
            </div>
        </div>
        <div class="row justify-content-center  pt-2">
            <div class="contain">
                <b-form-group
                    id="fieldset-2"
                    description=""
                    label="Phone Number"
                    label-for="phone"
                >
                    <div class="row">

                        <div class="col">
                            <b-form-input
                                id="phone"
                                v-model="formattedPhone"
                                lazy
                                aria-describedby="input-live-help input-live-feedback"
                                :class="{'is-valid': visitorInfo.phoneIsValid }"
                                @blur="updateSellerPhone()" required trim
                                pattern="[0-9]*" inputmode="numeric"
                                maxlength="14"
                                type="tel"
                                v-mask="'(###) ###-####'"
                                :disabled="visitorInfo.phoneIsValid"
                            ></b-form-input>
                        </div>

                    </div>
                    <b-form-invalid-feedback id="input-live-feedback">
                        Enter your 10 digit phone number
                    </b-form-invalid-feedback>

                    <div class="row align-middle pt-3" v-if="this.visitorInfo.phone">
                        <div class="align-middle" :class="hasRequestedPhoneVerificationCode ? 'col-8' : 'col-12'">
                            <div class="d-sm-inline-flex">Please verify your telephone</div>
                            <div class="d-sm-inline-flex pt-2">
                                <b-button pill size="sm" variant="primary" class="ml-4"
                                          :disabled="visitorInfo.phoneIsValid"
                                          @click="sendVisitorAVerificationCode('CALL')">Call me
                                </b-button>
                                <b-button pill size="sm" variant="primary" class="ml-4"
                                          :disabled="visitorInfo.phoneIsValid"
                                          @click="sendVisitorAVerificationCode('SMS')">Text me
                                </b-button>
                                <span
                                    v-if="!visitorInfo.phoneIsValid"
                                    class="ml-4 pt-1 font-weight-bold text-danger"
                                >
                                    required
                                </span>
                            </div>
                        </div>
                        <div v-if="hasRequestedPhoneVerificationCode" class="col-4 position-relative">
                            <b-spinner v-if="this.requesting" type="grow" label="Loading..." class="position-absolute r-0"></b-spinner>
                            <b-form-input maxlength="4" id="phone-verify" v-model="verificationCode" required trim
                                          pattern="[0-9]*" inputmode="numeric"
                                          @input="validateVisitorVerificationCode" :state="visitorInfo.phoneIsValid"
                                          @keypress.enter.prevent
                                          :disabled="visitorInfo.phoneIsValid"
                                          placeholder="Enter Code" style="min-width:108px"></b-form-input>
                        </div>
                    </div>
                    <div class="row" v-if="visitorInfo.phoneIsValid">
                        <div class="col">
                            <p class="mt-3 font-weight-bold text-success">Verified!</p>
                        </div>
                    </div>
                    <div class="row" v-if="apiErrorMessage">
                        <div class="col">
                            <p class="mt-3 font-weight-bold text-danger">{{ apiErrorMessage }}</p>
                        </div>
                    </div>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-center pt-2">
            <div class="contain">
                <b-form-group
                        id="fieldset-3"
                        description=""
                        label="Email"
                        label-for="email"

                >
                    <b-form-input id="email" v-model="visitorInfo.email" lazy
                                  @blur="updateSellerEmail()" trim
                                  :state="this.isElementValid($v.visitorInfo.email)"
                    ></b-form-input>
                    
                    <b-form-invalid-feedback id="input-live-feedback">
                        Enter your valid email address (john@example.com)
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="contain">

                <p style="font-weight: bold;">There's zero obligation and our service is 100% FREE.</p>

                <p>Why this information is required:</p>
                <ul class="info-list">
                    <li>In order to receive the advertised commissions from top agents in your market.</li>
                    <li>We use your name, email address and phone number to verify the accuracy of your submission.</li>
                    <li>We will not spam or sell your information like other real estate websites.</li>
                    <li>We use 256-bit encryption to keep your information secure.</li>
                </ul>
                <p class="agree-to-terms">
                  <label><input type="hidden" id="leadid_tcpa_disclosure"/>
                      By clicking "Finish" I expressly consent to receive autodialed/auto-selected and/or prerecorded 
                      marketing calls and/or texts to my telephone number provided above in order to receive information 
                      and promotional offers, even if I am on a federal or state do not call registry.  I represent that 
                      the phone number I enter is owned by me and /or I am its authorized user.  Calls/texts may be from 
                      Ideal Agent, one of Ideal Agent's network of Realtor partners, and/or Ideal Agent's moving 
                      concierge partner Infinity Sales Group.  I understand that consent is not a condition of purchase.  
                      Standard phone and messaging rates may apply.
                  </label>
                </p>
            </div>
        </div>
    </div>

</template>

<script>
    import {
        saveField,
        validateVerificationCode,
        sendVerificationCode,
        shouldValidatePhone
    } from "@/services/apiService";
    import {required, minLength, email} from 'vuelidate/lib/validators';
    import {mask} from 'vue-the-mask';

    export default {
        name: "VisitorInfo",
        props: ['value', 'source'],
        directives: {mask},
        data() {
            return {
                visitorInfo: {
                    firstName: this.value.firstName,
                    lastName: this.value.lastName,
                    phone: null,
                    phoneIsValid: null,
                    phoneIsVerified: false,
                    email: this.value.email
                },
                formattedPhone: this.value.phone,
                verificationCode: null,
                mustValidatePhone: null,
                apiErrorMessage: null,
                requesting: false,
                hasRequestedPhoneVerificationCode: false,
            }
        },
        validations: {
            visitorInfo: {
                firstName: {
                    required,
                    minLength: minLength(3)
                },
                lastName: {
                    required,
                    minLength: minLength(3)
                },
                email: {
                    required,
                    email
                },
            },
            formattedPhone: {
                required,
                minLength: minLength(14)
            }
        }
        ,
        methods: {
            showMessage: function (message) {
                this.$bvModal.msgBoxOk(message, {centered: true});
            },
            updateSellerFirstName: function () {
                this.$v.visitorInfo.firstName.$touch();
                if (!this.$v.visitorInfo.firstName.$invalid) {
                    this.$emit('input', this.visitorInfo);
                    saveField('First_Name', this.visitorInfo.firstName);
                }
            },
            updateSellerLastName: function () {
                this.$v.visitorInfo.lastName.$touch();
                if (!this.$v.visitorInfo.lastName.$invalid) {
                    this.$emit('input', this.visitorInfo);
                    saveField('Last_Name', this.visitorInfo.lastName);
                }
            },
            updateSellerPhone: function () {
                if (!this.formattedPhone) return;
                this.$v.formattedPhone.$touch();
                this.visitorInfo.phone = this.formattedPhone
                    .replace('(', '')
                    .replace(')', '')
                    .replace(' ', '')
                    .replace('-', '');
                this.$emit('input', this.visitorInfo);
                if (!this.$v.formattedPhone.$invalid) {
                    saveField('Mobile', this.visitorInfo.phone, this.mustValidate);
                }
            },
            updateSellerEmail: function () {
                this.$v.visitorInfo.email.$touch();
                this.$emit('input', this.visitorInfo);
                saveField('Email', this.visitorInfo.email);
            },
            sendVisitorAVerificationCode: async function (type) {
                if (!this.visitorInfo.phone || this.visitorInfo.phone.length != 10) {
                    this.showMessage('You must enter a 10 digit phone number first');
                    return;
                }
                this.hasRequestedPhoneVerificationCode = true;
                this.requesting = true;
                const response = await sendVerificationCode(type, this.visitorInfo.phone);
                this.requesting = false;
                this.apiErrorMessage = null;
                if (response?.errorMessage) {
                    this.apiErrorMessage = response.errorMessage;
                    return;
                }                
                if (response?.message === 'approved') {
                    this.visitorInfo.phoneIsValid = true;
                }
                else if (response?.message !== 'pending') {
                    console.error(`Unable to send code, error message: ${response.message}`)
                }
                else if (type === 'SMS') {
                    this.showMessage('Great! Now check your text messages and enter the code sent')
                } else {
                    this.showMessage('Great! Now answer the call to your phone and enter the code being spoken')
                }
            },

            validateVisitorVerificationCode: async function () {
                if (this.verificationCode.length !== 4) {
                    return;
                }
                this.requesting = true;
                const response = await validateVerificationCode(this.verificationCode, this.visitorInfo.phone);
                this.requesting = false;                
                this.apiErrorMessage = null;
                if (response?.errorMessage) {
                    this.apiErrorMessage = response.errorMessage;
                    return;
                }
                this.visitorInfo.phoneIsVerified = response?.status === 200;
                this.visitorInfo.phoneIsValid = response?.message === 'approved';
            },
            validateEmail: function (email) {
                const re = /\S+@\S+\.\S+/;
                return re.test(String(email).toLowerCase());
            },
            validateOnlyNumbers(phone) {
                const re = /\D/;
                return !re.test(phone);
            },
            validateName: function (name) {
                if (this.isEmpty(name)) {
                    this.states.name = false;
                    return;
                }
                if (this.name.length > 2) {
                    this.states.name = true;
                    return;
                }
                this.states.name = false;
            },
            /**
             * Determines if an element is valid and returns a value used for displaying validation
             * @param vFormElement vuelidate form element
             * @returns {null|boolean} null if the element hasn't been touched, false if it has been touched and fails validation
             * and true if it has been touched and passes validation
             */
            isElementValid: function (vFormElement) {
                if (!vFormElement) {
                    return null;
                }
                if (!vFormElement.$dirty) {
                    return null;
                }

                if (vFormElement.$invalid) {
                    return false;
                }

                if (!vFormElement.$invalid && vFormElement.$dirty) {
                    return true;
                }
                return null;
            }
        },
        async mounted() {
            let response = await shouldValidatePhone(this.source);
            this.mustValidatePhone = response ? response.data : false;
            if (this.value.phone) {
                this.$v.visitorInfo.email.$touch();
                this.$v.visitorInfo.firstName.$touch();
                this.$v.visitorInfo.lastName.$touch();
                this.$v.formattedPhone.$touch();         
                this.updateSellerPhone();
            }
        },
        computed: {
            mustValidate: function () {
                return this.mustValidatePhone;
            },
            phoneDigitsOnly: function () {
                return this.visitorInfo.phone
                    .replace('(', '')
                    .replace(')', '')
                    .replace(' ', '')
                    .replace('-', '');
            }
        }
    }
</script>

<style scoped>
.info-list {
    text-align: left;
    margin-left: 10px;
}

.info-list li {
    font-size: 0.75em;        
    text-align: justify;
}

.agree-to-terms {
    font-size: 0.75em;
}

.form-control.is-valid.is-invalid {
    border-color: #28a745;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}
</style>
